import type { ID } from '@octopus-do/octopus-project-core'
import { AngleDown } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { useState } from 'react'

import { clsJoin } from '@/utils'
import type { StructureSection } from '../../types'
import { TreeRow } from '../TreeRow'
import css from './styles.module.css'

interface Props {
  section: StructureSection
  selectedId: ID | null
  showDivider: boolean
  onSelect: (id: ID) => void
}

export const SectionGroup: React.FC<Props> = ({
  section,
  selectedId,
  showDivider,
  onSelect,
}) => {
  const [collapsed, setCollapsed] = useState(false)

  const handleToggle = () => setCollapsed(!collapsed)

  return (
    <>
      {showDivider && <div className={css.divider} />}

      <div className={css.group}>
        <button type="button" className={css.header} onClick={handleToggle}>
          <span
            className={clsJoin(css.chevron, collapsed && css.chevron_collapsed)}
          >
            <AngleDown />
          </span>

          {section.title}
        </button>

        {!collapsed &&
          section.roots.map((node) => (
            <TreeRow
              key={node.id}
              node={node}
              selectedId={selectedId}
              onSelect={onSelect}
            />
          ))}
      </div>
    </>
  )
}
